import dayjs from "dayjs"
import { convertFromRaw, convertToRaw } from "draft-js"


class Newsletter {
    constructor(newsletter) {
        const { id, name, status, system_area, official_release_date, description, image, content } = newsletter
        this.name = name
        this.id = id
        this.system_area = system_area
        this.image = image
        this.description = description
        this.content = content
        // if (content) {
        //     this.content = convertFromRaw(JSON.parse(content))
        // }
        this.status = status
        //datepicker format
        this.official_release_date = dayjs(new Date(official_release_date))
    }
}

export default Newsletter